// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cb075ac3","66":"5983f954","87":"920b6288","125":"9e0f75f9","875":"6b66b7c6","884":"8117ff71","955":"67f70b12"}[chunkId] + ".chunk.js";
};